import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#1A1A1A] group-[.toaster]:text-[#F2F2F2] group-[.toaster]:border-[#2A2A2A] group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-[#B9B9B9]",
          actionButton:
            "group-[.toast]:bg-[#D4A843] group-[.toast]:text-[#120F08]",
          cancelButton:
            "group-[.toast]:bg-[#2A2A2A] group-[.toast]:text-[#B9B9B9]",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
